import React from 'react';
import c from 'classnames';
import s from './InputFieldOutline.scss';
/** The outline and background for our input fields.  */
var InputFieldOutline = function (_a) {
    var outlineStyle = _a.outlineStyle, className = _a.className, children = _a.children;
    return (React.createElement("div", { className: c(s['root'], outlineStyle === 'success' && s['success'], outlineStyle === 'error' && s['error'], outlineStyle === 'disabled' && s['disabled'], className) }, children));
};
InputFieldOutline.displayName = 'InputFieldOutline';
export default InputFieldOutline;
//# sourceMappingURL=InputFieldOutline.js.map